import React, { useState, useEffect, useContext } from "react";
import Layout from "../../components/Layout/Layout";
import { db } from "../../firebase/firebase-config";
import { useAuthState } from 'react-firebase-hooks/auth';
import { collection, query, where, getDocs, doc, deleteDoc, getDoc } from "firebase/firestore";
import { Table, Input, Select } from 'antd';
import { auth } from '../../firebase/firebase-config';
import BeatLoader from "react-spinners/BeatLoader";
import BpCaseModal from "../../components/ui/BpCaseModal/BpCaseModal";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { BiUserPin } from 'react-icons/bi';
import PatientInfoModal from "./chart-modal/ChartModal";
import { BsFillTrashFill } from 'react-icons/bs';
import { ConfirmModal } from "../../components";
import { deleteUser } from "firebase/auth";
import { toast } from "react-toastify";
import ChartModal from "./chart-modal/ChartModal";
import DataTable from "./table/DataTable";
import moment from 'moment';
import ReadingsModal from "./ReadingsModal/ReadingsModal";
import { getDIACases } from "../../services/cases";

const { Search } = Input;


const override = {
  marginTop: "20px",
};


function Index() {
  const [allCasesData, setAllCasesData] = useState<any[]>([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [currentActiveCase, setCurrentActiveCase] = useState(null);

  const [searchText, setSearchText] = useState<string>('');
  const [filteredData, setFilteredData] = useState<any[]>(allCasesData);

  const [activeUserData, setActiveUserData] = useState(null);
  const [showLiveChart, setShowLiveChartModal] = useState(false);
  const [showCreateReadingsModal,setShowCreateReadingsModal] = useState(false);


  const [showConfirmodal, setShowConfirmModal] = useState(false);
  const [currentActiveId, setCurrentActiveId] = useState(null);

  const [user] = useAuthState(auth);


  const [loading, setLoading] = useState(false);

  const toggleAddModal = () => {
    setShowCreateModal(!showCreateModal);
  };

  const toggleReadingsModal = () => {
    setShowCreateReadingsModal(!showCreateReadingsModal);
  }

  const handleContentAdded = () => {
    setShowCreateModal(false);
    setShowCreateReadingsModal(false);
    //FETCH DATA
    fetchData();
  };

  

  // const fetchData = async () => {
  //   setLoading(true);
  //   const queryData = query(collection(db, "Cases"), where("label", "==", 'DIA'));

  //   // console.log('called')
  //   const querySnapshot = await getDocs(queryData);

  //   const casesData: any = [];

  //   // console.log(querySnapshot);
  //   // console.log('DATA LENGTH: ', querySnapshot.docs.length);

  //   setAllCasesData([]);
  //   querySnapshot.forEach(async (caseDoc) => {
  //       let readingDocRef = doc(collection(db,"LiveData"),caseDoc.id)
  //       let readingsDoc = await getDoc(readingDocRef);
      

  //       if(readingsDoc.exists())  {
  //           // console.log('READING: #####', readingsDoc.data())
  //           //Fetch Readings And Add To Data
            
  //           let data = {
  //               id: caseDoc.id,
  //               key: caseDoc.data().CID,
  //               readings: readingsDoc.data()?.readings,
  //               ...caseDoc.data()
  //             }
  //             // console.log('CASE DATA: ', caseDoc.data())
  //             // console.log('READINGS DATA: ', readingsDoc.data()?.readings)
  //             casesData.push(data);
  //             // console.log('DATA AFTER PUSH: ', casesData);
  //             setAllCasesData((prevItems: any) => [...prevItems, data]);
  //             // setAllCasesData([...allCasesData, data])
  //       }else {
  //           let data = {
  //               id: caseDoc.id,
  //               key: caseDoc.data().CID,
  //               readings: [],
  //               ...caseDoc.data()
  //             }
  //             // console.log('READINGS DOES NOT EXIST: ', caseDoc.data())
  //             casesData.push(data);
  //             // console.log('DATA AFTER PUSH: ', casesData);
  //             setAllCasesData((prevItems: any) => [...prevItems, data]);
  //             // setAllCasesData([...allCasesData, data])
  //       }    

  //   });
  //   // console.log('all data: ', casesData);
  //   // setAllCasesData(casesData);
  //   setLoading(false);
  // };

  const fetchData  = async () => {
    setLoading(true);
    getDIACases().then((res: any) => {
      setLoading(false);
      // console.log('RES DATA###: ', res.data);
      setAllCasesData(res?.data?.data);
    })
  }

  const setActiveCasetData = (data: any) => {
    // console.log('CASE DATA: ', data);
    setCurrentActiveCase(data);
    setShowCreateReadingsModal(true);
  }

  useEffect(() => {
    // console.log('FETCHING: ......')
    setAllCasesData([])
    fetchData();
  }, []);

  const [sortedInfo, setSortedInfo] = useState<any>({});

  const handleChange = (pagination: any, filters: any, sorter: any) => {
    setSortedInfo(sorter);
  };

  allCasesData.forEach((item: any, index: any) => {
    item.index = index + 1;
  });

  useEffect(() => {
    let fillData = filterData(allCasesData, searchText);
    const sortedData = fillData?.sort((a:any, b: any) => {
      const cidNumberA = parseInt(a.CID?.split('-')[1], 10);
      const cidNumberB = parseInt(b.CID?.split('-')[1], 10);
      return cidNumberB.toString().padStart(5, '0').localeCompare(cidNumberA.toString().padStart(5, '0'));
    });

    // console.log('FILTERED: ', fillData);

      setFilteredData(sortedData);

  }, [allCasesData, searchText]);

  const filterData = (data: any[], query: string) => {
    if (!query) return data;

    return data.filter((item) =>
      Object.values(item).some((value: any) =>
        value?.toString().toLowerCase().includes(query.toLowerCase())
      )
    );
  };


  const handleSearch = (value: string) => {
    setSearchText(value);
  };

  const deletePatient = async(patientId: any) => {

    // LOGIC TO DELETE PATIENT
    // deleteUser()
    // const docRef = doc(collection(db,"Patients"),patientId)
    // setShowConfirmModal(false);
    // if(patientId != null) {
    //     await deleteDoc(docRef).then(() => {
    //       fetchData();
    //       setShowConfirmModal(false);
    //       toast.success("Patient Deleted", {
    //         pauseOnHover: false,
    //         closeOnClick: true,
    //       });
    //     })
    // }
  }

  // useEffect(() => {
  //   alert('OKKK')
  // },[])


  return (
    <>
    <Layout title="Blood Sugar Cases" pageTitle="patients">
      <div className="section">
        <div className="parent-con">
          <div className="data-table">
            <div className="top">
              <div className="span">
                <h3>Blood Sugar Tracking Cases</h3>
              </div>

              <button 
               onClick={toggleAddModal}
              className="btn btn-primary btn-add student-button">
                New Case
              </button>
            </div>
            <div className="table-con">
                <div style={{ textAlign: "center" }}>
                  <BeatLoader
                    color="#3080ED"
                    loading={loading}
                    cssOverride={override}
                  />
                </div>
                <Search
                  placeholder="Search for data..."
                  onSearch={handleSearch}
                  onChange={(e) => handleSearch(e.target.value)}
                  value={searchText}
                  style={{ width: 200, marginBottom: 16 }}
                />

                    <DataTable key={allCasesData.length} data={filteredData}
                        toggleAddReportModal={() => {}}
                        setActiveCasetData={setActiveCasetData}
                        toggleAddReadingModal={toggleReadingsModal}
                    />
              
              </div>
  
          </div>
        </div>
      </div>
    </Layout>

    {showConfirmodal && (
          <ConfirmModal 
              title="Are you sure you want to delete patient ?"
              onAccept={() => deletePatient(currentActiveId)}
              onCancel={() => setShowConfirmModal(false)}
          />
      )}

     {showCreateModal && (
      <BpCaseModal
        onContentAdded={handleContentAdded}
        onClose={toggleAddModal}
        setActiveCasetData={setActiveCasetData}
      />
    )}

    {showCreateReadingsModal && (
      <ReadingsModal 
        onContentAdded={handleContentAdded}
        onClose={toggleReadingsModal}
        activeCaseData={currentActiveCase}
      />
    )}

    {showLiveChart && (
        <ChartModal user={activeUserData} onCancel={() => setShowLiveChartModal(false)} />
      )}
    </>
  );
}

export default Index;
